module.exports = __webpack_public_path__ + "static/media/google-play-badge256.c513510d.png";